// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__pg3KW","col":"styles_col__HhA3a"};